import { render, staticRenderFns } from "./PostCard.vue?vue&type=template&id=66c16945&scoped=true&lang=pug&"
import script from "./PostCard.vue?vue&type=script&lang=js&"
export * from "./PostCard.vue?vue&type=script&lang=js&"
import style0 from "./PostCard.vue?vue&type=style&index=0&id=66c16945&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c16945",
  null
  
)

export default component.exports